
import CatalogSource from "@/api/CatalogSource.js";

export const catalogModule = {

    state() {
        return {
            isLoading: false,
            catalog: [],
            popularItems: [],
        }
    },

    mutations: {
        setCatalog(state, data) {
            state.catalog = data;
        },
        setPopularItems(state, data) {
            state.popularItems = data;
        },
    },
    getters: {
        getFilterData: () => (rootState) => {
            return  {
                store_id: rootState.city.city_id
            };
        },
        getCategoryBySlug: (state) => (slug) => {
            return  state.catalog?.find(category => category.seo_url === slug);
        },
        getProductByCategoryIdAndProductId: (state) => (categoryId, productId) => {

            const category = state.catalog.find(category => category.category_id === categoryId);


            if (category && category.products) {
                return category.products.find(product => product.product_id === productId) || null;
            }

            return null;
        },
    },
    actions: {
        async load({state, rootState, getters, commit}) {
            try {
                state.isLoading = true;
                await this.$API.manager.getSource(CatalogSource).list(getters.getFilterData(rootState)).then(async (response) => {
                    await commit('setCatalog', response);
                    rootState.lastModified = response?.[0]?.date_modified ?? null;
                }).catch(() => {
                    commit('setCatalog', []);
                }).finally(() => {
                    state.isLoading = false;
                })
            } finally {
                state.isLoading = false;
            }
        },
        async popular_load({state, rootState, getters, commit}) {
            try {
                state.isLoading = true;
                await this.$API.manager.getSource(CatalogSource).popular_list(getters.getFilterData(rootState)).then(async (response) => {
                    await commit('setPopularItems', response);
                }).catch(() => {
                    commit('setPopularItems', []);
                }).finally(() => {
                    state.isLoading = false;
                })
            } finally {
                state.isLoading = false;
            }
        }
    },
    namespaced: true
}
